<template>
	<div class="wrap">
		<div class="tabBox">
			<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="activeSelect">
				<el-menu-item class="mrAll20" index="待反馈">待反馈</el-menu-item>
				<el-menu-item class="mrAll20" index="已反馈">已反馈</el-menu-item>
				<el-menu-item class="mrAll20" index="已删除">已删除</el-menu-item>
			</el-menu>
		</div>
		<div class="innerBox">
			<div class="conditionBox">
				<el-input placeholder="编号，投诉标题，投诉人，投诉人电话" class="w300 el-input_custom" v-model="getInfos.keysWork">
					<i slot="suffix" class="el-input__icon el-icon-search" @click="getTabInfo"></i>
				</el-input>
				<el-select v-if="subordinateData == '已删除'" v-model="getInfos.beforeState" class="ml20 w200" clearable placeholder="选择反馈状态" @change="getTabInfo">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<el-select v-model="getInfos.problemType" class="ml20 mr20 w200" placeholder="选择问题类型" clearable @change="getTabInfo">
					<el-option v-for="item in issueTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<el-select v-if="subordinateData == '已删除'" v-model="getInfos.closeCause" class="mr20 w200" clearable placeholder="选择关闭原因" @change="getTabInfo">
					<el-option v-for="item in closeTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<span class="mr10">投诉日期:</span>
				<el-date-picker @change="handleIconClick" value-format="yyyy-MM-dd" class=" w140 mr10" type="date" v-model="getInfos.startCreateTime"
					placeholder="选择起始日期" :picker-options="beforeDate"></el-date-picker>
				至
				<el-date-picker @change="handleIconClick" value-format="yyyy-MM-dd" v-model="getInfos.endCreateTime" class=" w140 ml10" type="date"
					placeholder="选择截止日期" :picker-options="afterDate"></el-date-picker>
				<span class="ml20 mr10" v-if="subordinateData == '已反馈'">反馈日期:</span>
				<el-date-picker v-if="subordinateData == '已反馈'" @change="handleIconClick" value-format="yyyy-MM-dd" class=" w140 mr10" type="date"
											  v-model="getInfos.startFeedbackTime" placeholder="选择起始日期" :picker-options="beforeDateF"></el-date-picker>
				<span v-if="subordinateData == '已反馈'">至</span>
				<el-date-picker v-if="subordinateData == '已反馈'" @change="handleIconClick" value-format="yyyy-MM-dd" v-model="getInfos.endFeedbackTime"
											  class=" w140 ml10" type="date" placeholder="选择截止日期" :picker-options="afterDateF"></el-date-picker>
				<el-button class="ml20" @click="resetAll">重置</el-button>
				<span class="ml20 showSpan" v-if="subordinateData == '已删除' && !showDown" @click="showDown = true">展开<i class="el-icon-arrow-down"></i></span>
				<span class="ml20 showSpan" v-if="subordinateData == '已删除' && showDown" @click="showDown = false">收起<i class="el-icon-arrow-up"></i></span>
				<div style="margin-left: 300px;" v-if="subordinateData == '已删除' && showDown">
					<span class="ml20 mr10">反馈日期:</span>
					<el-date-picker @change="handleIconClick" value-format="yyyy-MM-dd" class=" w140 mr10"
						type="date" v-model="getInfos.startFeedbackTime" placeholder="选择起始日期" :picker-options="beforeDateF"></el-date-picker>
					<span>至</span>
					<el-date-picker @change="handleIconClick" value-format="yyyy-MM-dd"
						v-model="getInfos.endFeedbackTime" class=" w140 ml10" type="date" placeholder="选择截止日期" :picker-options="afterDateF">
					</el-date-picker>
				</div>
			</div>
			<div class="warningBox mt20" v-if='warningShow'>
				<i class="el-icon-warning-outline"></i>
				删除后不能再进行反馈，也不会再公示系统中进行公示！
				<i class="el-icon-close floatR  movePoin" @click="warningShow=false"></i>
			</div>
			<el-table class="tableBox mt20" :key="getInfos.state" :data="tableData" @sort-change="sortChange">
				<el-table-column show-overflow-tooltip type="index" label="序号" min-width="50"></el-table-column>
				<el-table-column show-overflow-tooltip prop="complaintNo" label="编号" min-width="100"></el-table-column>
				<el-table-column show-overflow-tooltip prop="complaintTitle" label="投诉标题" min-width="120"></el-table-column>
				<el-table-column show-overflow-tooltip prop="problemType" label="问题类型" min-width="100"></el-table-column>
				<el-table-column show-overflow-tooltip prop="complaintContent" label="投诉内容" min-width="120"></el-table-column>
				<el-table-column show-overflow-tooltip prop="complaintPerson" label="投诉人" min-width="80"></el-table-column>
				<el-table-column show-overflow-tooltip prop="complaintPhone" label="投诉人电话" min-width="120"></el-table-column>
				<el-table-column show-overflow-tooltip prop="createTime" label="投诉时间" min-width="120" sortable='custom'></el-table-column>
				<el-table-column show-overflow-tooltip v-if="subordinateData == '已反馈'||subordinateData == '已删除'" prop="feedbackCompay" label="反馈部门" min-width="80"></el-table-column>
				<el-table-column show-overflow-tooltip v-if="subordinateData == '已反馈'||subordinateData == '已删除'" prop="feedbackPerson" label="反馈人" min-width="80"></el-table-column>
				<el-table-column show-overflow-tooltip v-if="subordinateData == '已反馈'||subordinateData == '已删除'" prop="feedbackTime" label="反馈人时间" min-width="120" sortable='custom'></el-table-column>
				<el-table-column show-overflow-tooltip v-if="subordinateData == '已删除'" prop="closeCause" label="删除原因" min-width="100"></el-table-column>
				<el-table-column show-overflow-tooltip v-if="subordinateData == '已删除'" prop="closeTime" label="关闭时间" min-width="120" sortable='custom'></el-table-column>
				<el-table-column label="操作" min-width="160">
					<template slot-scope="scope">
						<a href="javascript:" @click="infoTitChange(scope.row.id,'查看详情',true)" v-if="subordinateData == '待反馈'" class="operate-a">查看详情</a>
						<a href="javascript:" @click="infoTitChange(scope.row.id,'查看详情',true,'info')" v-if="subordinateData == '已反馈'" class="operate-a">查看详情</a>
						<a href="javascript:" @click="infoTitChange(scope.row.id,'反馈',true,'add')" v-if="subordinateData == '待反馈'" class="operate-a">反馈</a>
						<a href="javascript:" @click="infoTitChange(scope.row.id,'重新反馈',true,'edit')" v-if="subordinateData == '已反馈'" class="operate-a">重新反馈</a>
						<a href="javascript:" @click="operation(true,scope.row.id,scope.row.complaintTitle)" v-if="subordinateData == '已反馈'||subordinateData == '待反馈'" class="operate-a">删除</a>
						<a href="javascript:" @click="operation(false,scope.row.id,scope.row.complaintTitle)" v-if="subordinateData == '已删除'" class="operate-a">恢复</a>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-box">
				<el-pagination background @size-change="pageSizeChange" @current-change="pagecCurrentChange"
					:current-page="getInfos.current" :page-sizes="[10, 20, 30, 40,50]" :page-size="getInfos.size"
					layout="total,prev, pager, next, sizes, jumper" :total="getInfos.total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { getSchoolServerPage, getCloseOpen } from 'api/com'
	export default {
		props: {
			activeIndex: {
				default: function(){
					return '待反馈'
				}
			},
			subordinate: {
				default: function () {
					return '待反馈'
				}
			},
		},
		data() {
			return {
				warningShow:true,
				subordinateData: '',
				issueTypes: [
					{value:"01", label:"环境卫生"},
					{value:"02", label:"人员管理"},
					{value:"03",label: "食材问题"},
					{value:"04",label: "菜品问题"},
					{value:"05",label: "其他问题"}
				],
				closeTypes: [
					{value:"01", label:"无效信息"},
					{value:"02", label:"其他原因"},
				],
				options: [
					{ value: "01", label: "待反馈" },
					{ value: "02", label: "已反馈" },
				],
				mod:'',
				startDate: '',
				endDate:'',
				showDown: false,
				tableData: [],
				getInfos: {
					entityId: "",
					keysWork: '',
					problemType: '',
					size: 10,
					current: 1,
					sortColu: '',
					sortTypeL: '',
					startCreateTime: '',
					startFeedbackTime: '',
					state: '01',
					endFeedbackTime: '',
					endCreateTime: '',
					closeCause: '',
					beforeState: '',
					total: 0
				},
				afterDate: {
					disabledDate: (time) => {
						let startDate = new Date(this.getInfos.startCreateTime);
						if (this.getInfos.startCreateTime) {
							return time.getTime() < startDate - 8.64e7;
						}
					}
				},
				beforeDate: {
					disabledDate: (time) => {
						let endDate = new Date(this.getInfos.endCreateTime);
						if (this.getInfos.endCreateTime) {
							return time.getTime() > endDate;
						}
					}
				},
				afterDateF: {
					disabledDate: (time) => {
						let startDate = new Date(this.getInfos.startFeedbackTime);
						if (this.getInfos.startFeedbackTime) {
							return time.getTime() < startDate - 8.64e7;
						}
					}
				},
				beforeDateF: {
					disabledDate: (time) => {
						let endDate = new Date(this.getInfos.endFeedbackTime);
						if (this.getInfos.endFeedbackTime) {
							return time.getTime() > endDate;
						}
					}
				},
			}
		},
		mounted() {
			this.getInfos.entityId = this.$store.getters.user.deptId;
			this.subordinateData = this.subordinate;
			switch (this.subordinateData) {
				case '待反馈':
					this.getInfos.state = '01';
					break;
				case '已反馈':
					this.getInfos.state = '02';
					break;
				case '已删除':
					this.getInfos.state = '03';
					break;
			}
			this.getTabInfo()
		},
		methods: {
			activeSelect(index, indexPath) {
				switch (index) {
					case '待反馈':
						this.getInfos.state = '01';
						break;
					case '已反馈':
						this.getInfos.state = '02';
						break;
					case '已删除':
						this.getInfos.state = '03';
						break;
				}
        this.subordinateData = index;
				this.$emit('titChange', index);
				this.tableData = [];
				this.resetAll();
			},
			infoTitChange(id,name,complaintShow, feedbackState){
				this.$emit('infoTitChange',id, name, complaintShow, feedbackState)
			},
			getTabInfo(){
				getSchoolServerPage(this.getInfos).then((r)=>{
					if (r.code != 200) {
						this.$message.error(r.msg);
						return
					}
					this.tableData = r.data.records;
					this.getInfos.total = r.data.total;
				})
			},
			resetAll() {
				this.getInfos.keysWork = '';
				this.getInfos.problemType = '';
				this.getInfos.startCreateTime = '';
				this.getInfos.endCreateTime = '';
				this.getInfos.startFeedbackTime = '';
				this.getInfos.endFeedbackTime = '';
				this.getInfos.size = 10;
				this.getInfos.current = 1;
				this.getTabInfo();
			},
			operation(type,id,name){
				if(type){
					if(this.getInfos.state == '02'){
						this.$confirm('删除后该信息将不会公示！是否删除?', '删除提醒', {
							confirmButtonText: '确定',
							cancelButtonText: '取消'
						}).then(() => {
							let params = {
								id: id,
								type: '1'
							}
							getCloseOpen(params).then(r => {
								if (r.code == 200) {
									this.$message.success('删除成功!');
									this.getTabInfo();
								}
							})
						}).catch(() => {
							this.$message.info('已取消删除');
						});
					}else {
						let _html = `
							<p style="font-size:14px;line-height:35px;color:#666;"><span>投诉标题：</span>${name}</p>
							<p style="font-size:14px;line-height:35px;color:#666;">
								<span>删除原因：</span>
								<select style="line-height:25px;height:25px;" id="mySelect" class="w200" placeholder="选择问题类型">
									<option value="01">无效信息</option>
									<option value="02">其他原因</option>
								</select>
							</p>
							<p style="font-size:12px;color:#999;margin-top: 10px;">删除后不能再进行反馈，也不会在公示系统中进行公示！</p>
						`
						this.$alert(_html, '删除提醒', {
							dangerouslyUseHTMLString: true
						}).then(()=>{
							let params = {
								id: id,
								type: '1',
								closeCause: document.getElementById('mySelect').value
							}
							getCloseOpen(params).then(r => {
								if(r.code == 200){
									this.$message.success('删除成功!');
									this.getTabInfo();
								}
							})
						}).catch(() => {
							this.$message.info('已取消删除');
						});
					}
				}else {
					this.$confirm('该记录恢复后将显示在已反馈列表，并进行公示！是否恢复?', '恢复提醒', {
						confirmButtonText: '确定',
						cancelButtonText: '取消'
					}).then(() => {
						let params = {
							id: id,
							type: '0'
						}
						getCloseOpen(params).then(r => {
							if (r.code == 200) {
								this.$message.success('恢复成功!');
								this.getTabInfo();
							}
						})
					}).catch(() => {
						this.$message.info('已取消恢复');
					});
				}
			},
			handleIconClick(){},
			pageSizeChange(size) {
				this.getInfos.size = size;
				this.getTabInfo();
			},
			pagecCurrentChange(current){
				this.getInfos.current = current;
				this.getTabInfo();
			},
			sortChange() {}
		}
	}
</script>

<style scoped lang="scss">
	.wrap {
		width: calc(100% - 40px);
		padding: 0 20px;
		height: 100%;
		background: #f6f6f6;
		.tabBox{
			margin-bottom: 10px;
			border-radius: 4px;
			.el-menu-demo{
				border-radius: 4px;
			}
		}
		.innerBox {
			width: calc(100% - 60px);
			padding: 20px 30px;
			height: calc(100% - 125px);
			background: #fff;
			border-radius: 10px;
			.conditionBox{
				padding-bottom: 20px;
				border-bottom: 1px solid #EEEEEE;
				line-height: 45px;
				.showSpan{
					font-size: 14px;
					color: #333;
					i{
						margin-left: 5px;
					}
				}
			}
			.warningBox{
				height:40px;
				line-height: 40px;
				background:rgba(254,249,234,1);
				border-radius:2px;
				border:1px solid rgba(253,195,78,1);
				padding: 0 20px;
				color: #F29D13;
				font-size: 14px;
				.el-icon-close{
					color: #666666;
					font-size: 16px;
					margin-top: 12px;
				}
			}
			.tableBox{
				text-align: left;
			}
			.pagination-box {
				text-align: right;
				margin-top: 20px;
			}
		}
	}
	.mrAll20{
		margin: 0 20px;
		border-bottom-width: 4px !important;
	}
	.colorG{
		color: #70CE97;
	}
</style>